export const VSAT = {
  id: "vsat",
  name: "VSAT",
  imageFolder: "/vsat",
  tagline: {
    pt: "VSAT — Internet via satélite, VoIP, e redes remotas para indústria e mineração.",
    en: "VSAT — Satellite internet, VoIP, and remote networks for industry and mining.",
    es: "VSAT — Internet satelital, VoIP, y redes remotas para industria y minería.",
  },
  color: "#1e3a8a",
  theme: {
    bgGradient: "from-[#e8eef9] via-[#d8e8f5] to-[#eef4fb]",
    blob1: "bg-indigo-300/30",
    blob2: "bg-blue-200/40",
    overlineText: "text-indigo-800",
    pillarPill: "border-indigo-400 text-indigo-800",
    segmentHover: "hover:border-indigo-400",
    tabHover: "hover:border-indigo-400 hover:text-indigo-800",
    ctaPrimary:
      "bg-indigo-800 hover:bg-indigo-900 shadow-indigo-800/25 hover:shadow-indigo-800/40",
    ctaOutline: "border-indigo-400 text-indigo-800 hover:bg-indigo-50",
    productHover: "hover:border-indigo-400",
    productQuoteCta: "border-indigo-400 text-indigo-800 hover:bg-indigo-50",
    productBadge: "text-indigo-800",
    productPreviewPill: "text-indigo-800",
    whyPanel: "border-indigo-200 from-indigo-50 to-white",
    whyItemBorder: "border-indigo-100",
    whyCheck: "text-indigo-700",
    modalHeaderBg: "from-indigo-50 via-[#d8e8f5] to-blue-50",
    modalBrandBadge: "border-indigo-200 text-indigo-800",
    modalInputFocus: "focus:border-indigo-500 focus:ring-indigo-500/20",
    modalSubmit:
      "bg-indigo-800 hover:bg-indigo-900 shadow-indigo-800/25 hover:shadow-indigo-800/40",
  },
  pillars: {
    pt: ["Internet Satélite", "Banda C", "Banda Ku & Ka", "Soluções Remotas"],
    en: ["Satellite Internet", "C-band", "Ku & Ka Band", "Remote Solutions"],
    es: ["Internet Satélite", "Banda C", "Banda Ku y Ka", "Soluciones Remotas"],
  },
  segments: {
    pt: [
      { name: "Mineração", desc: "Conectividade em zonas remotas sem infra-estrutura terrestre." },
      { name: "Petróleo & Gás", desc: "Comunicação crítica em plataformas, refinarias e campos de exploração." },
      { name: "Indústria", desc: "Redes de dados para fábricas e sites industriais afastados." },
      { name: "ONGs & Saúde", desc: "Ligação de emergência em áreas rurais e acampamentos humanitários." },
      { name: "Marítimo", desc: "Comunicação offshore para barcos de pesca e cargo." },
      { name: "Backup Empresarial", desc: "Redundância via satélite para sedes com links críticos." },
    ],
    en: [
      { name: "Mining", desc: "Connectivity in remote areas without terrestrial infrastructure." },
      { name: "Oil & Gas", desc: "Mission-critical communication in platforms, refineries and exploration fields." },
      { name: "Industry", desc: "Data networks for factories and remote industrial sites." },
      { name: "NGOs & Health", desc: "Emergency connectivity in rural areas and humanitarian camps." },
      { name: "Maritime", desc: "Offshore communication for fishing and cargo vessels." },
      { name: "Enterprise Backup", desc: "Satellite redundancy for HQs with critical links." },
    ],
    es: [
      { name: "Minería", desc: "Conectividad en zonas remotas sin infraestructura terrestre." },
      { name: "Petróleo y Gas", desc: "Comunicación crítica en plataformas, refinerías y campos de exploración." },
      { name: "Industria", desc: "Redes de datos para fábricas y sitios industriales remotos." },
      { name: "ONGs y Salud", desc: "Conectividad de emergencia en zonas rurales y campos humanitarios." },
      { name: "Marítimo", desc: "Comunicación offshore para barcos pesqueros y de carga." },
      { name: "Backup Empresarial", desc: "Redundancia satelital para sedes con enlaces críticos." },
    ],
  },
  why: {
    pt: {
      title: "Porquê escolher VSAT?",
      items: [
        "Cobertura em todo o território angolano",
        "Instalação rápida em qualquer local",
        "Links dedicados ou partilhados (CIR)",
        "Integração com VoIP e redes LAN",
        "Antenas 1.2m, 1.8m e 2.4m (Ku / Ka band)",
        "Assistência e manutenção em Angola",
      ],
    },
    en: {
      title: "Why choose VSAT?",
      items: [
        "Coverage across all of Angola",
        "Rapid installation anywhere",
        "Dedicated or shared links (CIR)",
        "Integration with VoIP and LAN networks",
        "1.2m, 1.8m and 2.4m dishes (Ku / Ka band)",
        "Local support and maintenance",
      ],
    },
    es: {
      title: "¿Por qué elegir VSAT?",
      items: [
        "Cobertura en todo el territorio angoleño",
        "Instalación rápida en cualquier sitio",
        "Enlaces dedicados o compartidos (CIR)",
        "Integración con VoIP y redes LAN",
        "Antenas 1.2m, 1.8m y 2.4m (banda Ku / Ka)",
        "Soporte y mantenimiento local",
      ],
    },
  },
  groups: [
    {
      id: "antenas-modems",
      icon: "antenna",
      featured: true,
      title: {
        pt: "Antenas & Modems",
        en: "Antennas & Modems",
        es: "Antenas y Módems",
      },
      description: {
        pt: "Equipamento VSAT ground station — antenas parabólicas Banda C de 1.8 m a 3.8 m e Banda Ku/Ka de 1.2 m a 2.4 m, modems satélite iDirect e Hughes, BUCs, LNBs PLL e mounts não-penetrantes.",
        en: "VSAT ground station equipment — C-band dishes from 1.8 m to 3.8 m and Ku/Ka-band from 1.2 m to 2.4 m, iDirect and Hughes satellite modems, BUCs, PLL LNBs and non-penetrating mounts.",
        es: "Equipamiento VSAT ground station — antenas Banda C de 1.8 m a 3.8 m y Banda Ku/Ka de 1.2 m a 2.4 m, módems iDirect y Hughes, BUCs, LNBs PLL y mounts no penetrantes.",
      },
      highlights: {
        pt: [
          "Antenas Banda C: 1.8 m, 2.4 m e 3.8 m (alta disponibilidade, anti rain-fade)",
          "Antenas Banda Ku/Ka: 1.2 m, 1.8 m e 2.4 m",
          "Modems iDirect X7, X1 e Hughes HN9460",
          "BUCs Banda C (5 W, 10 W, 20 W)",
          "LNBs PLL Banda C, Ku e Ka",
          "Feedhorns e OMT (Orthomode Transducer)",
          "Cabos coaxiais N-type e mounts não-penetrantes",
          "Suportadas pelo satélite ANGOSAT-2",
        ],
        en: [
          "C-band dishes: 1.8 m, 2.4 m and 3.8 m (high-availability, rain-fade resistant)",
          "Ku/Ka-band dishes: 1.2 m, 1.8 m and 2.4 m",
          "iDirect X7, X1 and Hughes HN9460 modems",
          "C-band BUCs (5W, 10W, 20W)",
          "C, Ku and Ka-band PLL LNBs",
          "Feedhorns and OMT (Orthomode Transducer)",
          "N-type coaxial cabling and non-penetrating mounts",
          "Powered by the ANGOSAT-2 satellite",
        ],
        es: [
          "Antenas Banda C: 1.8 m, 2.4 m y 3.8 m (alta disponibilidad, anti rain-fade)",
          "Antenas Banda Ku/Ka: 1.2 m, 1.8 m y 2.4 m",
          "Módems iDirect X7, X1 y Hughes HN9460",
          "BUCs Banda C (5 W, 10 W, 20 W)",
          "LNBs PLL Banda C, Ku y Ka",
          "Feedhorns y OMT (Orthomode Transducer)",
          "Cables coaxiales N-type y mounts no penetrantes",
          "Compatibles con el satélite ANGOSAT-2",
        ],
      },
      products: [
        {
          slug: "vsat-antenna-cband-3m8",
          pt: "Antena Banda C 3.8 m — Parabólica de alta capacidade para mineração e broadcast",
          en: "C-band 3.8 m Antenna — High-capacity dish for mining and broadcast",
          es: "Antena Banda C 3.8 m — Parabólica de alta capacidad para minería y broadcast",
        },
        {
          slug: "vsat-antenna-cband-2m4",
          pt: "Antena Banda C 2.4 m — Anti rain-fade para petrolíferas e indústria",
          en: "C-band 2.4 m Antenna — Rain-fade resistant for oil & gas and industry",
          es: "Antena Banda C 2.4 m — Anti rain-fade para petroleras e industria",
        },
        {
          slug: "vsat-antenna-cband-1m8",
          pt: "Antena Banda C 1.8 m — Solução compacta de alta disponibilidade",
          en: "C-band 1.8 m Antenna — Compact high-availability solution",
          es: "Antena Banda C 1.8 m — Solución compacta de alta disponibilidad",
        },
        {
          slug: "vsat-antenna-1m2",
          pt: "Antena VSAT Ku 1.2 m — Parabólica para PME",
          en: "VSAT 1.2 m Antenna — Ku-band dish for SMB",
          es: "Antena VSAT 1.2 m — Parabólica banda Ku para pymes",
        },
        {
          slug: "vsat-antenna-2m4",
          pt: "Antena VSAT Ku 2.4 m — Parabólica de alta capacidade",
          en: "VSAT 2.4 m Antenna — High-capacity Ku-band dish",
          es: "Antena VSAT 2.4 m — Parabólica de alta capacidad banda Ku",
        },
        {
          slug: "idirect-x7-modem",
          pt: "iDirect X7 — Modem satélite empresarial",
          en: "iDirect X7 — Enterprise satellite modem",
          es: "iDirect X7 — Módem satelital empresarial",
        },
        {
          slug: "hughes-hn9460",
          pt: "Hughes HN9460 — Modem VSAT banda Ka",
          en: "Hughes HN9460 — Ka-band VSAT modem",
          es: "Hughes HN9460 — Módem VSAT banda Ka",
        },
        {
          slug: "vsat-buc-cband",
          pt: "BUC Banda C 10 W — Amplificador de subida (5 W / 10 W / 20 W)",
          en: "C-band BUC 10W — Block-up converter (5W / 10W / 20W)",
          es: "BUC Banda C 10 W — Amplificador de subida (5 W / 10 W / 20 W)",
        },
        {
          slug: "vsat-buc-6w",
          pt: "BUC Banda Ku 6 W — Amplificador de subida",
          en: "Ku-band BUC 6W — Block-up converter",
          es: "BUC Banda Ku 6 W — Amplificador de subida",
        },
        {
          slug: "vsat-lnb-cband",
          pt: "LNB Banda C — Downconverter PLL de baixo ruído",
          en: "C-band LNB — Low-noise PLL downconverter",
          es: "LNB Banda C — Downconverter PLL de bajo ruido",
        },
        {
          slug: "vsat-lnb-ku",
          pt: "LNB Banda Ku — Downconverter PLL de alta estabilidade",
          en: "Ku-band LNB — High-stability PLL downconverter",
          es: "LNB Banda Ku — Downconverter PLL de alta estabilidad",
        },
        {
          slug: "vsat-feed-cband",
          pt: "Feedhorn & OMT Banda C — Conjunto guia de onda",
          en: "C-band Feedhorn & OMT — Waveguide assembly",
          es: "Feedhorn y OMT Banda C — Conjunto guía de onda",
        },
        {
          slug: "vsat-cable-coax",
          pt: "Cabo Coaxial RF — Baixa perda com conectores N-type",
          en: "RF Coaxial Cable — Low-loss with N-type connectors",
          es: "Cable Coaxial RF — Baja pérdida con conectores N-type",
        },
        {
          slug: "vsat-mount-pole",
          pt: "Mount Não-Penetrante — Suporte de aço para antenas grandes",
          en: "Non-Penetrating Mount — Steel support for large dishes",
          es: "Mount No Penetrante — Soporte de acero para antenas grandes",
        },
      ],
    },
    {
      id: "modems-cband",
      icon: "router",
      title: {
        pt: "Modems Banda C",
        en: "C-Band Modems",
        es: "Módems Banda C",
      },
      description: {
        pt: "Modems satélite Banda C de operadores e fabricantes líderes — DVB-S2/S2X, SCPC, TDMA e iDirect Evolution. Suportam links empresariais, broadcast e redes mineiras com alta disponibilidade.",
        en: "C-band satellite modems from leading vendors — DVB-S2/S2X, SCPC, TDMA and iDirect Evolution. Suitable for enterprise links, broadcast and mining networks with high availability.",
        es: "Módems satelitales Banda C de fabricantes líderes — DVB-S2/S2X, SCPC, TDMA e iDirect Evolution. Soportan enlaces empresariales, broadcast y redes mineras con alta disponibilidad.",
      },
      highlights: {
        pt: [
          "Comtech CDM-625A — modem SCPC avançado com VersaFEC",
          "iDirect Evolution 950mp — terminal remoto TDMA/SCPC",
          "Hughes HX200 — modem broadband VSAT empresarial",
          "Newtec / ST Engineering MDM3100 — DVB-S2X de alta capacidade",
          "Gilat SkyEdge II-c Capricorn — terminal de banda larga",
          "ST Engineering iDirect iQ Desktop — geração mais recente",
        ],
        en: [
          "Comtech CDM-625A — advanced SCPC modem with VersaFEC",
          "iDirect Evolution 950mp — TDMA/SCPC remote terminal",
          "Hughes HX200 — enterprise broadband VSAT modem",
          "Newtec / ST Engineering MDM3100 — high-capacity DVB-S2X",
          "Gilat SkyEdge II-c Capricorn — broadband terminal",
          "ST Engineering iDirect iQ Desktop — latest generation",
        ],
        es: [
          "Comtech CDM-625A — módem SCPC avanzado con VersaFEC",
          "iDirect Evolution 950mp — terminal remoto TDMA/SCPC",
          "Hughes HX200 — módem broadband VSAT empresarial",
          "Newtec / ST Engineering MDM3100 — DVB-S2X de alta capacidad",
          "Gilat SkyEdge II-c Capricorn — terminal de banda ancha",
          "ST Engineering iDirect iQ Desktop — última generación",
        ],
      },
      products: [
        {
          slug: "vsat-modem-comtech-cdm625a",
          pt: "Comtech CDM-625A — Modem SCPC avançado com VersaFEC e ACM",
          en: "Comtech CDM-625A — Advanced SCPC modem with VersaFEC and ACM",
          es: "Comtech CDM-625A — Módem SCPC avanzado con VersaFEC y ACM",
        },
        {
          slug: "vsat-modem-idirect-950mp",
          pt: "iDirect Evolution 950mp — Terminal remoto Banda C TDMA/SCPC",
          en: "iDirect Evolution 950mp — C-band TDMA/SCPC remote terminal",
          es: "iDirect Evolution 950mp — Terminal remoto Banda C TDMA/SCPC",
        },
        {
          slug: "vsat-modem-hughes-hx200",
          pt: "Hughes HX200 — Modem VSAT empresarial broadband Banda C",
          en: "Hughes HX200 — Enterprise C-band broadband VSAT modem",
          es: "Hughes HX200 — Módem VSAT empresarial banda ancha Banda C",
        },
        {
          slug: "vsat-modem-newtec-mdm3100",
          pt: "Newtec MDM3100 (ST Engineering iDirect Dialog) — DVB-S2X de alta capacidade",
          en: "Newtec MDM3100 (ST Engineering iDirect Dialog) — High-capacity DVB-S2X",
          es: "Newtec MDM3100 (ST Engineering iDirect Dialog) — DVB-S2X de alta capacidad",
        },
        {
          slug: "vsat-modem-gilat-skyedge2c",
          pt: "Gilat SkyEdge II-c Capricorn — Terminal VSAT Banda C de banda larga",
          en: "Gilat SkyEdge II-c Capricorn — C-band broadband VSAT terminal",
          es: "Gilat SkyEdge II-c Capricorn — Terminal VSAT Banda C de banda ancha",
        },
        {
          slug: "vsat-modem-iq-desktop",
          pt: "ST Engineering iDirect iQ Desktop — Modem de nova geração com DVB-S2X",
          en: "ST Engineering iDirect iQ Desktop — Next-gen DVB-S2X modem",
          es: "ST Engineering iDirect iQ Desktop — Módem de nueva generación con DVB-S2X",
        },
      ],
    },
    {
      id: "solucoes",
      icon: "globe",
      title: {
        pt: "Soluções Chave-na-Mão",
        en: "Turnkey Solutions",
        es: "Soluciones Llave-en-Mano",
      },
      description: {
        pt: "Soluções completas de comunicação por satélite — internet dedicada, VoIP satélite e kits para sites remotos com energia solar e abrigo.",
        en: "Complete satellite communication solutions — dedicated internet, satellite VoIP and remote-site kits with solar power and enclosure.",
        es: "Soluciones completas de comunicación satelital — internet dedicada, VoIP satelital y kits para sitios remotos con energía solar y abrigo.",
      },
      products: [
        {
          slug: "vsat-voip-phone",
          pt: "Phone-Sat — Telefone VoIP satélite outdoor com solar",
          en: "Phone-Sat — Outdoor satellite VoIP phone with solar",
          es: "Phone-Sat — Teléfono VoIP satelital outdoor con solar",
        },
        {
          slug: "vsat-remote-site",
          pt: "Site Remoto — Kit completo VSAT + energia + abrigo",
          en: "Remote Site — Complete VSAT + power + enclosure kit",
          es: "Sitio Remoto — Kit completo VSAT + energía + abrigo",
        },
      ],
    },
  ],
};
